<template>
    <li class="flex flex-row items-start gap-2 text-gray-700 font-light leading-snug">
        <span class="h-lh flex items-center shrink-0">
            <CheckIcon class="size-5 text-gray-600 shrink-0" />
        </span>
        <span>
            <slot />
        </span>
    </li>
</template>

<script setup lang="ts">
import CheckIcon from '../Icon/CheckIcon.vue';
</script>
